import React from 'react'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { List, ListItemButton, ListItemText, ListSubheader, Box, Button } from '@mui/material';

function FirstChild({ children, parentName, setFChild, setSChild ,handleChild, handleToggle, checked}) {
    return (

        <List>
            <ListSubheader sx={{ backgroundColor: 'rgb(245, 242, 242)' }}>
                {parentName}
            </ListSubheader>
            <Box display='flex' justifyContent='space-between' mt={1}>
                <Button onClick={()=> setFChild(false)} style={{ textTransform: 'none' }} ><ArrowBackIosNewOutlinedIcon sx={{fontSize: '14px'}}/>&nbsp;Back</Button>
                <Button onClick={()=>{setFChild(false); setSChild(false)}} style={{ textTransform: 'none' }} ><MenuOutlinedIcon sx={{fontSize: '14px'}}/>&nbsp;All Categories</Button>
            </Box>
            {children.map(item => (
                <ListItemButton key={item.id} onClick={()=> item.children?handleChild(item.id, item.label):handleToggle(item.id, item)} sx={{backgroundColor: checked.includes(item.id)? '#daebe8': 'transparent'}}>
                    <ListItemText primary={item.label} />
                    {item.children && <ChevronRightOutlinedIcon />}
                </ListItemButton>
            ))}
        </List>
    )
}

export default FirstChild